import { createSelector } from 'reselect';
import { get } from 'lodash';
import { combineReducers } from 'redux';
import loginReducer from './Login/loginViewState';
import navigationReducer from './Navigation/viewState';
import updatePasswordReducer from './UpdatePassword/updatePasswordViewState';
import searchReducer from './Search/searchViewState';
import merchantSelectorReducer from './MerchantSelector/merchantSelectorViewState';
import payoutAccountSelectorReducer from './PayoutAccountSelector/payoutAccountSelectorViewState';
import modalReducer from './Modal/modalViewState';

export const viewStates = combineReducers({
    login: loginReducer,
    merchantSelector: merchantSelectorReducer,
    payoutAccountSelector: payoutAccountSelectorReducer,
    modal: modalReducer,
    navigation: navigationReducer,
    search: searchReducer,
    updatePassword: updatePasswordReducer
});

export const getViewStates = createSelector(
    (state) => state,
    (state) => get(state, 'viewStates')
);

export const getViewStateByName = createSelector(
    getViewStates,
    (state, name) => name,
    (viewStates, name) => get(viewStates, name)
);
